import { useState, useMemo } from 'react';
import useAsyncEffect from 'use-async-effect';
import { useMytaverseEvent } from '@core/dashboard/providers';
import StreamService from '@services/StreamService';
import { getAverageValue } from '@core/devices/components/DevicesTest/ConnectionTest/helpers';
import { delay } from '@helpers/index';

export const useCheckServiceLatency = (isFirstTestCompleted: boolean) => {
  const [serviceLatencies, setServiceLatencies] = useState<number[]>([]);
  const [isCompleted, setIsCompleted] = useState(false);

  const { gameCastStreamRegion, currentEvent } = useMytaverseEvent();

  const averageServiceLatency = useMemo(
    () => getAverageValue(serviceLatencies),
    [serviceLatencies],
  );

  useAsyncEffect(async () => {
    const region = gameCastStreamRegion || currentEvent?.region;

    if (!isFirstTestCompleted || !region) {
      return;
    }

    const setServiceLatencyValue = async () => {
      await delay(1000);
      const serviceLatency = await StreamService.checkServiceLatency(
        currentEvent?.eventRelease.gameliftEC2InstanceRegion || region,
      );

      setServiceLatencies((prev) => prev.concat(serviceLatency));
    };

    const startCheckServiceLatency = async () => {
      const checkServiceLatencyList = [...new Array(5)];

      for (const [i] of checkServiceLatencyList.entries()) {
        await setServiceLatencyValue();

        if (i === checkServiceLatencyList.length - 1) {
          setIsCompleted(true);
        }
      }
    };

    startCheckServiceLatency();
  }, [currentEvent, gameCastStreamRegion, isFirstTestCompleted]);

  return {
    serviceLatency: averageServiceLatency,
    isCompleted,
  };
};
